var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingSharedafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "parkingShared_after_svg__Ebene_1",
    "data-name": "Ebene 1",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingShared_after_svg__cls-20,.parkingShared_after_svg__cls-21,.parkingShared_after_svg__cls-3,.parkingShared_after_svg__cls-6{fill:#fff}.parkingShared_after_svg__cls-19,.parkingShared_after_svg__cls-3,.parkingShared_after_svg__cls-5,.parkingShared_after_svg__cls-9{stroke:#343a50;stroke-miterlimit:10}.parkingShared_after_svg__cls-3,.parkingShared_after_svg__cls-5{stroke-width:2px}.parkingShared_after_svg__cls-5{fill:#7e7e7e}.parkingShared_after_svg__cls-19,.parkingShared_after_svg__cls-9{stroke-width:3px}.parkingShared_after_svg__cls-9{fill:#464655}.parkingShared_after_svg__cls-20,.parkingShared_after_svg__cls-21{font-family:Lato-Regular,Lato}.parkingShared_after_svg__cls-16{letter-spacing:0}.parkingShared_after_svg__cls-19{fill:#065494}.parkingShared_after_svg__cls-20{font-size:80.47px}.parkingShared_after_svg__cls-21{font-size:20px}.parkingShared_after_svg__cls-22{letter-spacing:.01em}.parkingShared_after_svg__cls-23{letter-spacing:-.01em}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg__Privatparkplatz_teilen_Nachher",
    "data-name": "Privatparkplatz teilen_Nachher"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1261.03,
    height: 821.37,
    x: -1.5,
    y: 260.18,
    fill: "#4f4f4e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a50",
    d: "M1258 261.7V1080H0V261.7h1258m3-3H-3v824.39h1264V258.67z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg__Weniger_Parkpl\\xE4tze_Vorher",
    "data-name": "Weniger Parkpl\\xE4tze_Vorher"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.66,
    height: 675.86,
    x: 857.75,
    y: 255.67,
    className: "parkingShared_after_svg__cls-3",
    transform: "rotate(-6.1 878.86 593.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingShared_after_svg__Weniger_Parkpl\\xE4tze_Vorher-2",
    width: 675.86,
    height: 43.66,
    x: 40.62,
    y: 571.77,
    className: "parkingShared_after_svg__cls-3",
    "data-name": "Weniger Parkpl\\xE4tze_Vorher",
    transform: "rotate(-83.9 378.586 593.617)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 79.35,
    height: 67.7,
    x: 1,
    y: 0.98,
    fill: "#7e7e7e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 80.35,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 159.44,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 238.53,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 317.62,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 396.72,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 475.81,
    y: 0.98,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 68.68 554.9 68.68 554.9 .98 633.99 1 633.99 68.68",
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.68,
    x: 633.99,
    y: 1,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: -38.29,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 40.8,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 119.89,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 198.99,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 278.08,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 357.17,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 436.26,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 515.35,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 594.45,
    y: 68.68,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 1.26,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 80.35,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 159.44,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 238.53,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 317.62,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 396.72,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 475.81,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 554.9,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 633.99,
    y: 136.06,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: -38.29,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 40.8,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 119.89,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 198.99,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 278.08,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 357.17,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 436.26,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 515.35,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 594.45,
    y: 203.45,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 713,
    y: 1,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 791.82,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 870.65,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 949.48,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1028.3,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1107.13,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1185.96,
    y: 0.99,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 673.59,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 752.41,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 831.24,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 910.06,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 988.89,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1067.72,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1146.54,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1225.37,
    y: 68.38,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 713,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 791.82,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 870.65,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 949.48,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1028.3,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1107.13,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1185.96,
    y: 135.76,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 673.59,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 752.41,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 831.24,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 910.06,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 988.89,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1067.72,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1146.54,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1225.37,
    y: 203.15,
    className: "parkingShared_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg___41",
    "data-name": 41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.62 406.27v-20.22H101.9v-6.63L136.2 332h11.24v46.15h10.77v7.89h-10.77v20.22zm0-28.11v-24.79q0-5.82.36-11.65h-.36c-2.36 4.34-4.26 7.54-6.39 11l-18.8 25.24v.23zM188.73 341.38h-.24l-13.37 7-2-7.66 16.8-8.68h8.87v74.26h-10.06z",
    className: "parkingShared_after_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg___43",
    "data-name": 43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1087 406.27v-20.22h-35.73v-6.63l34.3-47.42h11.24v46.15h10.76v7.89h-10.76v20.22zm0-28.11v-24.79q0-5.82.35-11.65h-.35c-2.37 4.34-4.26 7.54-6.39 11l-18.81 25.24v.23zM1118 394.73a35.69 35.69 0 0017 4.68c13.37 0 17.51-8.22 17.4-14.39-.12-10.4-9.82-14.85-19.88-14.85h-5.8v-7.54h5.8c7.57 0 17.15-3.77 17.15-12.57 0-5.94-3.9-11.2-13.48-11.2a28.86 28.86 0 00-15.38 4.92l-2.72-7.32c4-2.85 11.83-5.71 20.11-5.71 15.14 0 22 8.68 22 17.71 0 7.65-4.73 14.17-14.19 17.48v.23c9.46 1.83 17.15 8.68 17.15 19.08 0 11.88-9.58 22.27-28 22.27-8.63 0-16.2-2.62-20-5z",
    className: "parkingShared_after_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg__Handy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707384",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M920.19 1038.45l-233.93-115A60.9 60.9 0 01658.47 842l237.67-484a60.84 60.84 0 0181.45-27.8l233.94 115a60.9 60.9 0 0127.79 81.5l-237.67 484a60.85 60.85 0 01-81.46 27.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63afdb",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M934.91 951l-188.48-92.6A49.06 49.06 0 01724 792.73l191.49-390a49 49 0 0165.63-22.4L1169.65 473a49.08 49.08 0 0122.35 65.69l-191.45 389.95A49 49 0 01934.91 951z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.1,
    cy: 939.22,
    r: 22.33,
    className: "parkingShared_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.29 433.52l-45.63-22.43a8.27 8.27 0 01-3.78-11.07 8.28 8.28 0 0111.07-3.78l45.63 22.43a8.27 8.27 0 013.78 11.07 8.28 8.28 0 01-11.07 3.78z",
    className: "parkingShared_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1055.18,
    cy: 391.81,
    r: 8.43,
    className: "parkingShared_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#468cbe",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1058.61 810.41L782.18 674.56l135.64-276.23c10.72-21.84 39.23-29.8 63.67-17.79l187.91 92.35c24.45 12 35.57 39.46 24.85 61.3z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 194.73,
    transform: "matrix(.93 .46 -.44 .9 958.04 543.56)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 70.18,
    transform: "rotate(25.8 -836.629 2124.234)"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.03em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.51,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.33,
    y: 0,
    letterSpacing: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.56,
    y: 0,
    letterSpacing: ".02em"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 126.67,
    y: 0,
    className: "parkingShared_after_svg__cls-16"
  }, "pl"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.16,
    y: 0,
    letterSpacing: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 216.7,
    y: 0,
    className: "parkingShared_after_svg__cls-16"
  }, "tz"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.47,
    y: 69
  }, "mie"), /*#__PURE__*/React.createElement("tspan", {
    x: 141.58,
    y: 69,
    letterSpacing: "-.01em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 164.38,
    y: 69
  }, "en")), /*#__PURE__*/React.createElement("path", {
    d: "M853 749.42l28.36 13.94-13.94 28.36-28.36-13.94L853 749.42m-1.37-4l-16.58 33.75 33.74 16.59L885.41 762l-33.75-16.6z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 852.97,
    y: 763.24,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 860.333 770.633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.66 785.11L954 799.05l-13.94 28.36-28.36-13.93 13.94-28.37m-1.37-4l-16.58 33.74 33.74 16.59L958 797.68l-33.71-16.58z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 925.75,
    y: 799.01,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 933.106 806.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.34 822.05L845.7 836l-13.94 28.36-28.36-13.95 13.94-28.36M816 818l-16.59 33.75 33.75 16.58 16.59-33.74L816 818z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 817.26,
    y: 835.91,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 824.595 843.288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 857.74l28.36 13.94L904.39 900 876 886.1l14-28.36m-1.37-4L872 887.47l33.75 16.59 16.58-33.75-33.73-16.58z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 889.89,
    y: 871.6,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 897.24 878.984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.19 799.75l33.5 16.46-16.46 33.5-33.5-16.46 16.46-33.5m-1.37-4l-19.1 38.88 38.88 19.11 19.11-38.89-38.89-19.1z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 871.5,
    y: 817.51,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 878.863 824.892)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 858.67,
    y: 843.43,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 866.02 850.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 884.28,
    y: 791.48,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 891.654 798.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 845.44,
    y: 804.72,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 852.809 812.106)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 897.53,
    y: 830.27,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 904.864 837.646)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 828.69,
    y: 812.66,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 836.038 820.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 841.54,
    y: 786.51,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 848.895 793.902)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 904.18,
    y: 849.78,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 911.531 857.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 917.04,
    y: 823.62,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 924.383 831)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 839.16,
    y: 850.08,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 846.5 857.446)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 865.32,
    y: 862.94,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 872.666 870.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 877.62,
    y: 771.94,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 884.982 779.324)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 903.83,
    y: 784.82,
    className: "parkingShared_after_svg__cls-6",
    transform: "rotate(26.17 911.195 792.21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_after_svg__Schilder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.18,
    height: 170.22,
    x: 576.83,
    y: 18.3,
    className: "parkingShared_after_svg__cls-19",
    rx: 24.63
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-20",
    transform: "matrix(1.04 0 0 1 608.74 87.09)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-21",
    transform: "matrix(1.04 0 0 1 582.67 108.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_after_svg__cls-22"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.32,
    y: 0
  }, "ie"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.02,
    y: 0,
    className: "parkingShared_after_svg__cls-23"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e mich")), /*#__PURE__*/React.createElement("path", {
    d: "M618.06 119.89v16.48h-16.49v-16.48h16.49m1.57-1.57H600v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 606.01,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.28 119.89v16.48h-16.49v-16.48h16.49m1.57-1.57h-19.62v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 648.32,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.06 162.11v16.49h-16.49v-16.49h16.49m1.57-1.57H600v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 606.01,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.28 162.11v16.49h-16.49v-16.49h16.49m1.57-1.57h-19.62v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 648.24,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.66 139.51V159h-19.47v-19.49h19.47m1.57-1.57h-22.6v22.6h22.6v-22.6z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 627.18,
    y: 145.45,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 627.13,
    y: 160.54,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 627.18,
    y: 130.32,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 612.03,
    y: 145.46,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 642.3,
    y: 145.44,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 606.01,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 606.01,
    y: 137.83,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 649.9,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 649.9,
    y: 137.84,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 619.53,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 634.74,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 619.56,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 634.8,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108.18,
    height: 170.22,
    x: 119.02,
    y: 18.3,
    className: "parkingShared_after_svg__cls-19",
    rx: 24.63
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-20",
    transform: "matrix(1.04 0 0 1 150.92 87.09)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-21",
    transform: "matrix(1.04 0 0 1 124.86 108.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_after_svg__cls-22"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.32,
    y: 0
  }, "ie"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.02,
    y: 0,
    className: "parkingShared_after_svg__cls-23"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e mich")), /*#__PURE__*/React.createElement("path", {
    d: "M160.25 119.89v16.48h-16.49v-16.48h16.49m1.56-1.57h-19.62v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 148.2,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47 119.89v16.48H186v-16.48h16.49m1.56-1.57h-19.64v19.62H204v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 190.51,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25 162.11v16.49h-16.49v-16.49h16.49m1.56-1.57h-19.62v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 148.2,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47 162.11v16.49H186v-16.49h16.49m1.56-1.57h-19.64v19.62H204v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 190.42,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.85 139.51V159h-19.47v-19.49h19.47m1.56-1.57h-22.6v22.6h22.6v-22.6z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 169.36,
    y: 145.45,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 169.32,
    y: 160.54,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 169.36,
    y: 130.32,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 154.22,
    y: 145.46,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 184.49,
    y: 145.44,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 148.2,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 148.2,
    y: 137.83,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 192.09,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 192.09,
    y: 137.84,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 161.71,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 176.92,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 161.74,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 176.98,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108.18,
    height: 170.22,
    x: 1064.78,
    y: 18.3,
    className: "parkingShared_after_svg__cls-19",
    rx: 24.63
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-20",
    transform: "matrix(1.04 0 0 1 1096.69 87.09)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_after_svg__cls-21",
    transform: "matrix(1.04 0 0 1 1070.62 108.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_after_svg__cls-22"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.32,
    y: 0
  }, "ie"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.02,
    y: 0,
    className: "parkingShared_after_svg__cls-23"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e mich")), /*#__PURE__*/React.createElement("path", {
    d: "M1106 119.89v16.48h-16.49v-16.48H1106m1.56-1.57H1088v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1093.96,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.23 119.89v16.48h-16.49v-16.48h16.49m1.56-1.57h-19.61v19.62h19.61v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1136.27,
    y: 124.3,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106 162.11v16.49h-16.49v-16.49H1106m1.56-1.57H1088v19.62h19.62v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1093.96,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.23 162.11v16.49h-16.49v-16.49h16.49m1.56-1.57h-19.61v19.62h19.61v-19.62z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1136.18,
    y: 166.55,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.61 139.51V159h-19.47v-19.49h19.47m1.57-1.57h-22.61v22.6h22.61v-22.6z",
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1115.12,
    y: 145.45,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1115.08,
    y: 160.54,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1115.12,
    y: 130.32,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1099.98,
    y: 145.46,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1130.25,
    y: 145.44,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1093.96,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1093.96,
    y: 137.83,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1137.85,
    y: 153.04,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1137.85,
    y: 137.84,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1107.48,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 7.6,
    x: 1122.68,
    y: 168.15,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1107.5,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.62,
    height: 7.62,
    x: 1122.74,
    y: 122.7,
    className: "parkingShared_after_svg__cls-6"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 114.24,
    transform: "matrix(1.04 0 0 1 564.41 408.21)"
  }, "\r\n   42\r\n  "))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSharedafter);
export default __webpack_public_path__ + "static/media/parkingShared.after.eca14512.svg";
export { ForwardRef as ReactComponent };